module.exports = __webpack_public_path__ + "static/media/icon8.65cc5d2b.png";